import PageHero from '../components/PageHero'
import PageCardImage from '../components/PageCardImage'
import { INDUSTRIES_CONTENT } from '../content/industriesContent'

export default function IndustriesPage() {
  return (
    <div className="page">
      <PageHero
        title={INDUSTRIES_CONTENT.title}
        lead={INDUSTRIES_CONTENT.intro}
        image={INDUSTRIES_CONTENT.heroImage}
        imageAlt="Industries served by Aegis Professional Services"
      />

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="page-grid page-grid--3">
            {INDUSTRIES_CONTENT.sectors.map((sector) => (
              <article key={sector.title} className="page-card page-card--media">
                <PageCardImage src={sector.image} alt={sector.title} />
                <h2 className="page-card__title">{sector.title}</h2>
                <p className="page-card__text">{sector.desc}</p>
                <p className="page-card__text page-card__text--muted">{sector.details}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="page-section page-section--alt">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="page-section__title">Supply Chain Coverage</h2>
          <div className="page-gallery">
            {INDUSTRIES_CONTENT.gallery.map((item) => (
              <figure key={item.label} className="page-gallery__item">
                <img src={item.image} alt={item.label} className="page-gallery__image" loading="lazy" />
                <figcaption className="page-gallery__caption">{item.label}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="page-section__title">Facility Types We Support</h2>
          <ul className="page-list page-list--columns">
            {INDUSTRIES_CONTENT.facilityTypes.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  )
}
